export default __webpack_public_path__ + "static/media/mail_purple_24dp.0f62918e.svg";